import React, { Component } from "react"
import PropTypes from "prop-types"

class SelectList extends Component {
  state = { value: this.props.initialSelection ? this.props.initialSelection.id : "" }

  onSelectChange = (e) => {
    this.setState({ value: e.target.value })
    this.props.onSelectChange(e)
  }

  setInitialOption = () => {
    return (
      <option
        disabled={this.props.initialSelection.disabled}
        key={this.props.initialSelection.id}
        value={this.props.initialSelection.id}
      >
        {this.props.initialSelection.text}
      </option>
    )
  }

  generateOptions = () => {
    const options = this.props.data

    if (options && options.length > 0) {
      return options.map((q) => {
        if (q.enabled === false) {
          if (!isNaN(q.count)) {
            return (
              <option disabled key={q.id} value={q.id}>
                {q.text} ({q.count})
              </option>
            )
          }
          return (
            <option disabled key={q.id} value={q.id}>
              {q.text}
            </option>
          )
        }
        if (!isNaN(q.count)) {
          return (
            <option key={q.id} value={q.id}>
              {q.text} ({q.count})
            </option>
          )
        }
        return (
          <option key={q.id} value={q.id}>
            {q.text}
          </option>
        )
      })
    }
    return <option />
  }

  render() {
    return (
      <select className="form-control" onChange={this.onSelectChange} value={this.state.value}>
        {this.props.initialSelection ? this.setInitialOption() : null}
        {this.generateOptions()}
      </select>
    )
  }
}

SelectList.propTypes = {
  initialSelection: PropTypes.shape({
    id: PropTypes.number.isRequired,
    text: PropTypes.string.isRequired,
    disabled: PropTypes.bool,
  }),
  onSelectChange: PropTypes.func.isRequired,
  data: PropTypes.arrayOf(PropTypes.shape({
    id: PropTypes.number.isRequired,
    text: PropTypes.string.isRequired,
    count: PropTypes.number,
  })).isRequired,
}

SelectList.defaultProps = {
  initialSelection: null,
}

export default SelectList



// WEBPACK FOOTER //
// ./src/components/inputs/SelectList.jsx